// extracted by mini-css-extract-plugin
export default {"appliedPricing":"AppliedPricing_appliedPricing__mndq3","tick":"AppliedPricing_tick__ttHA4"};